import { FC } from "react";

import WidgetContainer, {
  WidgetContainerProps,
} from "src/dynamic-view-renderer/Widgets/WidgetContainer.tsx";
import { AlertTimeline } from "src/pages/AlertDetails/cards/AlertTimelineTile.tsx";
import { Alert } from "src/types/alert.ts";

export type ChronologyWidgetProps = {
  data?: {
    alert?: Alert | null;
  };
} & Omit<WidgetContainerProps, "children">;

const ChronologyWidget: FC<ChronologyWidgetProps> = ({ data, ...containerProps }) => {
  const alert = data?.alert;
  return (
    <WidgetContainer {...containerProps}>
      <AlertTimeline alert={alert} />
    </WidgetContainer>
  );
};

export default ChronologyWidget;
